module.exports = __webpack_public_path__ + "img/Newbie_Dagger_03_Mage.7d472d8a.png";